var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVertexAi36Color(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30,20.84a1.13,1.13,0,0,0-1.58-.24L18,28.32v.32a1.08,1.08,0,1,1,0,2.16v.05a1.08,1.08,0,0,0,.67-.22l11.12-8.21A1.13,1.13,0,0,0,30,20.84Z",
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,30.8a1.08,1.08,0,1,1,0-2.16h0v-.32L7.55,20.6a1.13,1.13,0,1,0-1.34,1.82l11.12,8.21a1.12,1.12,0,0,0,.67.22V30.8Z",
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,27.51a2.21,2.21,0,1,0,2.21,2.21A2.21,2.21,0,0,0,18,27.51Zm0,3.29a1.08,1.08,0,1,1,1.08-1.08A1.09,1.09,0,0,1,18,30.8Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.16A1.14,1.14,0,0,1,7.83,8V5.2a1.13,1.13,0,1,1,2.26,0V8A1.13,1.13,0,0,1,9,9.16Z",
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.96,
    cy: 18,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.96,
    cy: 14.68,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.96,
    cy: 11.35,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,12.45a1.12,1.12,0,0,1-1.13-1.13V8.5a1.13,1.13,0,0,1,2.26,0v2.82A1.13,1.13,0,0,1,27,12.45Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.04,
    cy: 18.02,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.04,
    cy: 14.64,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.04,
    cy: 5.21,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,22.47a1.13,1.13,0,0,1-1.13-1.13V18.52a1.13,1.13,0,1,1,2.26,0v2.82A1.13,1.13,0,0,1,18,22.47Z",
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24.67,
    r: 1.13,
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15.2,
    r: 1.13,
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 11.88,
    r: 1.13,
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.52,15.81a1.13,1.13,0,0,1-1.13-1.13V11.85a1.13,1.13,0,0,1,2.26,0v2.83A1.14,1.14,0,0,1,22.52,15.81Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.52,
    cy: 8.53,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.52,
    cy: 21.29,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.52,
    cy: 17.96,
    r: 1.13,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.48,
    cy: 21.29,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.48,
    cy: 11.88,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.48,
    cy: 8.53,
    r: 1.13,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.48,19.1A1.14,1.14,0,0,1,12.35,18V15.14a1.13,1.13,0,1,1,2.26,0V18A1.13,1.13,0,0,1,13.48,19.1Z",
    style: {
      fill: "#aecbfa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertexAi36Color);
export default __webpack_public_path__ + "static/media/vertex-ai-36-color.2e41aaf913c70e966fc13bd9b88c8684.svg";
export { ForwardRef as ReactComponent };